import React from 'react';

export const DialogBody = ({ children, className }) => (
  <div className={`ct-dialog-body ${className || ''}`}>{children}</div>
);
